import { Injectable } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Observable, of } from 'rxjs';

import { AjaxService } from '../../services/ajax.service';
import { ORDER_DEMO } from '../../services/account-api.constants';



@Injectable({
  providedIn: 'root'
})

export class LandinglService 
{
	public dialogChangesMade = false;   // For tracing if eye-dialog made any changes.

	constructor(
		private ajaxService: AjaxService,
	) 
	{ }


	public submitRequesstForADemo(comapnyName:string, contactName:string, contactEmail: string, contactPhone:string, freeMessage:string)
	{
		const apiUrl = this.ajaxService.getBaseOfApi() + ORDER_DEMO;
		const payload = this.createPayloadReqDemo(comapnyName, contactName, contactEmail, contactPhone, freeMessage);
		return this.ajaxService.updateObjectData(apiUrl, payload);
	}


	private createPayloadReqDemo(comapnyName:string, contactName:string, contactEmail: string, contactPhone:string, freeMessage:string)
	{
		const payload = 
		{
			company			: 	comapnyName,
			fullName		:	contactName,
			businessEmail	:	contactEmail,
			phone			:	contactPhone,
			message			:	freeMessage
		};

		return JSON.stringify(payload);
	}
}